import { AppealStatus, APPEAL_STATUS_LABEL, APPEAL_STATUS_COLOR } from '@repo/types';

import { get } from 'lodash';

const buildStatusClasses = (color: string, mode: 'light' | 'dark') =>
  mode === 'dark'
    ? `text-[#FFFFFF] bg-[${color}] border-[${color}]`
    : `text-[${color}] bg-[${color}]/20 border-[${color}]/40`;

const useAppealStatus = (mode: 'dark' | 'light') => {
  const getAppealStatusLabel = (appealStatus: AppealStatus): string =>
    get(APPEAL_STATUS_LABEL, appealStatus, appealStatus);
  const getAppealStatusColor = (appealStatus: AppealStatus): string => {
    const color = APPEAL_STATUS_COLOR[appealStatus];
    if (!color) return 'text-xtnd-dark dark:text-xtnd-light';
    return buildStatusClasses(color, mode);
  };

  return { getAppealStatusLabel, getAppealStatusColor };
};

export default useAppealStatus;
